import { Post } from '../http/httpVerbs';

const URL = `${process.env.REACT_APP_API_URL}/auth/pearson/login/`;

export const apiPearsonLogin = async (email, password) => {
    const response = await Post(URL, { 
        email, 
        password 
    });
    return response;
};

export const apiPearsonTokenLogin = async (token) => {
    const response = await Post(URL, { 
        token 
    });
    return response;
};

export const apiPearsonFirstAccess = async (email) => {
    const response = await Post(URL, { 
        email 
    });
    return response;
};
